import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Centro, Linha } from '../../styles/base';

const GeraDiaDaSemana = (dia) => {
  if (dia === '1') {
    return 'Segunda-Feira';
  }
  if (dia === '2') {
    return 'Terça-Feira';
  }
  if (dia === '3') {
    return 'Quarta-Feira';
  }
  if (dia === '4') {
    return 'Quinta-Feira';
  }
  if (dia === '5') {
    return 'Sexta-Feira';
  }
  if (dia === '6') {
    return 'Sábado';
  }
  if (dia === '7') {
    return 'Domingo';
  }
  return '';
};

const ListaColeta = ({
  DiaSemana, EnderecoAte, EnderecoDe, Horario, Id,
}) => (
  <div
    className="controle-fundo"
    style={{
      border: '1px solid #c1c1c1', padding: '15px', background: '#f1f1f1',
    }}
  >
    <p>
      <span style={{ fontWeight: 'bold' }}>Dia da semana: </span>
      {GeraDiaDaSemana(DiaSemana)}
    </p>
    <p>
      <span style={{ fontWeight: 'bold' }}>Horário: </span>
      {Horario}

    </p>
    <div>
      {EnderecoAte && (
        <p style={{ fontSize: '11px', marginBottom: '5px', marginTop: '5px' }}>
          <span style={{ fontWeight: 'bold' }}>Endereço até: </span>
          {EnderecoAte}
        </p>
      )}

      {EnderecoDe && (
        <p style={{ fontSize: '11px', marginBottom: '5px', marginTop: '5px' }}>
          <span style={{ fontWeight: 'bold' }}>Endereço de: </span>
          {EnderecoDe}
        </p>
      )}
    </div>
  </div>
);

ListaColeta.propTypes = {
  DiaSemana: PropTypes.string,
  EnderecoAte: PropTypes.string,
  EnderecoDe: PropTypes.string,
  Horario: PropTypes.string,
  Id: PropTypes.string,
};

ListaColeta.defaultProps = {
  DiaSemana: '',
  EnderecoAte: '',
  EnderecoDe: '',
  Horario: '',
  Id: '',
};

export default ListaColeta;
